import { render, staticRenderFns } from "./InsuranceSkladUsaTableMobile.vue?vue&type=template&id=4a2346a8&scoped=true"
import script from "./InsuranceSkladUsaTableMobile.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2346a8",
  null
  
)

export default component.exports